<template>
  <div class="container">

    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one>メールアドレス・お知らせ通知設定の変更</heading-one>

    <wizard-group class="_mb-md-60 _mb-sm-20">
      <main-wizard :active-index="2" type="useremail"></main-wizard>
    </wizard-group>

    <p>以下の内容で変更しました。<br>
      その他のお客さま情報を変更する場合は、「お客さま情報を確認する」より変更する箇所をご選択のうえお手続きください。</p>

    <section>
      <table-group>
        <table-box class="_mb-10">
          <table-body>
            <template v-if="!localUser">
              <!-- au IDに紐づくアドレスあり -->
              <template v-if="showDefaultMail">
                <table-row>
                  <table-header rowspan="3">
                    メールアドレス※
                  </table-header>
                  <table-data>
                    {{displayEzMail}}
                  </table-data>
                </table-row>
                <table-row>
                  <table-data>
                    {{displayMail1}}
                  </table-data>
                </table-row>
                <table-row>
                  <table-data>
                    {{displayMail2}}
                  </table-data>
                </table-row>
              </template>
            </template>
            <!-- その他のアドレス -->
            <table-row>
              <table-header>
                メールアドレス
                <change-badge-icon :diffKeys="diffKeys" :key-list="['loan_mail']"></change-badge-icon>
              </table-header>
              <table-data>
                {{displayLoanMail}}
              </table-data>
            </table-row>
            <table-row>
              <table-header>
                お知らせ通知設定
                <change-badge-icon :diffKeys="diffKeys" :key-list="['cpn_ukt_flg', 'kri_tti_ukt_flg', 'hen_soku_ukt_flg', 'mns_stm_ukt_flg']"></change-badge-icon>
              </table-header>
              <table-data>
                <template v-if="userData.cpn_ukt_flg === '1'"><span :class="{'red': isChangeNotice('cpn_ukt_flg')}">・キャンペーン情報</span><br /></template>
                <template v-if="userData.kri_tti_ukt_flg === '1'"><span :class="{'red': isChangeNotice('kri_tti_ukt_flg')}">・お借り入れ時</span><br /></template>
                <template v-if="userData.hen_soku_ukt_flg === '1'"><span :class="{'red': isChangeNotice('hen_soku_ukt_flg')}">・ご返済時</span><br /></template>
                <template v-if="userData.mns_stm_ukt_flg === '1'"><span :class="{'red': isChangeNotice('mns_stm_ukt_flg')}">・マンスリーステートメント発行</span><br /></template>
              </table-data>
            </table-row>
          </table-body>
        </table-box>
      </table-group>
      <div class="_mb-md-60 _mb-sm-30"><small>※au IDにご登録の連絡先メールアドレスを表示しております。変更をご希望の場合は、<a href="https://id.auone.jp/" class="btn-text textlink" target="_blank">au IDサイト</a>にて連絡先メールアドレスをご登録ください。</small></div>

      <btngroup-single class="_mb-md-120 _mb-sm-40">
        <btn-main class="-main" router-name="mb023">
          お客さま情報を確認する
        </btn-main>
      </btngroup-single>

    </section>

  </div><!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from '../utils/LambdaHelper'
import userData from '../components/mixin/UserData'
import changeIcon from '../components/mixin/ChangeIcon'

import ErrorsAlert from '../components/alert/ErrorsAlert'
import HeadingOne from '../components/heading/HeadingOne'
import WizardGroup from '../components/wizard/WizardGroup'
import MainWizard from '../components/wizard/MainWizard'
import TableGroup from '../components/tables/TableGroup'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import BtnTooltip from '../components/button/BtnTooltip'
import TooltipsItem from '../components/tooltip/TooltipsItem'
import TableData from '../components/tables/TableData'
import BadgeIcon from '../components/badges/BadgeIcon'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import ChangeBadgeIcon from '../components/badges/ChangeBadgeIcon'

export default {
  name: 'Tem-019',
  metaInfo: {
    title: 'メールアドレス・お知らせ通知設定の変更｜お客さま情報の確認・変更',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報'}
    ]
  },
  mixins: [userData, changeIcon],
  components: {
    ChangeBadgeIcon,
    BtnMain,
    BtngroupSingle,
    BadgeIcon,
    TableData,
    TooltipsItem,
    BtnTooltip,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    MainWizard,
    WizardGroup,
    HeadingOne,
    ErrorsAlert
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: 'お客さま情報の確認・変更',
        routerName: 'mb023'
      },
      {
        text: 'メールアドレス・お知らせ通知設定の変更',
        active: true
      }
      ],
      userData: {
        id_type: '',
        ez_mail: '',
        mail_1: '',
        mail_2: '',
        loan_mail: '',
        loan_mail_confirmation: '',
        cpn_ukt_flg: '',
        hen_soku_ukt_flg: '',
        kri_tti_ukt_flg: '',
        mns_stm_ukt_flg: ''
      }
    }
  },
  mounted () {
    try {
      getUserDataLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key]
          }
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
  .table-data {
    >.red {
      color: $danger;
      font-weight: bold;
    }
  }
  .btn-text {
    &:hover {
      text-decoration: underline;
      color: $orange !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Tem019.vue